<div class="card w-100">
    <div class="card-header d-flex justify-content-between align-items-end">
        <span class="title mb-0">Mis Trámites</span>
    </div>

    <div class="card-body px-0 px-md-3">

        <!-- Cargando -->
        <div *ngIf="isLoading" class="text-center py-5">
            <i class="fa fa-spinner fa-spin fa-3x text-primary"></i>
            <p class="mt-3">Cargando solicitudes...</p>
        </div>

        <ng-container *ngIf="!isLoading">

            <!-- Sin solicitudes -->
            <div *ngIf="!hasData" class="text-center py-5 text-muted">
                <i class="fa fa-folder-open-o fa-3x mb-3 d-block"></i>
                <p>Aún no tienes solicitudes de trámites.</p>
                <a class="btn btn-primary mt-2" routerLink="/ciudadano/tramites">Ver catálogo de trámites</a>
            </div>

            <!-- Tabla de solicitudes -->
            <div *ngIf="hasData" class="table-responsive">
                <table class="table tramites-table">
                    <thead>
                        <tr>
                            <th>Folio</th>
                            <th>Trámite</th>
                            <th>Fecha</th>
                            <th>Estatus</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let req of data">
                            <td class="folio-cell">{{ req.Folio || '—' }}</td>
                            <td class="title-cell">{{ req.Procedure?.Title || '—' }}</td>
                            <td class="date-cell">{{ req.created_at | date: 'dd/MM/yyyy' }}</td>
                            <td class="status-cell">
                                <span class="status-badge" [ngClass]="statusClass(req.Status)">
                                    {{ displayStatus(req.Status) }}
                                </span>
                            </td>
                            <td class="action-cell">
                                <div class="action-buttons" *ngIf="getAction(req) as action">
                                    <a
                                        *ngIf="action.type !== 'download'"
                                        class="btn-action"
                                        [class.btn-action--primary]="action.type === 'continue' || action.type === 'respond'"
                                        [class.btn-action--secondary]="action.type === 'view'"
                                        [routerLink]="formLink(req)"
                                        [queryParams]="formQueryParams(req)"
                                    >
                                        {{ action.label }}
                                        <i class="fa fa-arrow-right ml-1" *ngIf="action.type === 'continue' || action.type === 'respond'"></i>
                                        <i class="fa fa-eye ml-1" *ngIf="action.type === 'view'"></i>
                                    </a>
                                    <button
                                        *ngIf="canDownload(req)"
                                        type="button"
                                        class="btn-action btn-action--download"
                                        [disabled]="downloadingId === req.id"
                                        (click)="downloadOutput(req, $event)"
                                    >
                                        <i class="fa" [ngClass]="downloadingId === req.id ? 'fa-spinner fa-spin' : 'fa-download'"></i>
                                        Descargar
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!-- Paginación -->
                <div *ngIf="totalPages > 1" class="mt-3 d-flex justify-content-center">
                    <ngb-pagination
                        [collectionSize]="totalRecords"
                        [(page)]="page"
                        [pageSize]="pageSize"
                        [maxSize]="5"
                        [rotate]="true"
                        [boundaryLinks]="true"
                        (pageChange)="loadPage($event)">
                    </ngb-pagination>
                </div>
            </div>

        </ng-container>
    </div>
</div>
